import { AppAccent } from 'src/app/core/types/app-accent.type';
import { AppVisualContextService } from '../../services/app-visual-context.service';
import { HostBinding, inject, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-card',
  templateUrl: './menu-card.component.html',
  styleUrl: './menu-card.component.css',
})
export class MenuCardComponent implements OnInit {
  @Input() accent?: AppAccent;
  private readonly visualContext = inject(AppVisualContextService);
  @HostBinding('class') get visualClass(): string {
    return this.accent === undefined ? '' : this.visualContext.classForInputs(this.accent);
  }

  @Input({ required: true }) icon: string;
  @Input({ required: true }) title: string;
  @Input({ required: true }) subtitle: string;
  @Input({ required: false }) path: string;

  constructor() {}

  ngOnInit(): void {}
}
